import React, { useState } from 'react';
import { Alert, TextField, Button, Box, Typography, Link, Paper, Snackbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const REGISTRATION_QUEUE_URL =
  process.env.REACT_APP_REGISTRATION_QUEUE_URL ||
  'https://0urp7fhu11.execute-api.us-east-2.amazonaws.com/prod/queue-user-registration';

function RegistrationPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');


  const handleRegister = async () => {
    if (!name || !email || !password || !confirmPassword) {
      setError('Please fill in all required fields.');
      setSuccess('');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      setSuccess('');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      setSuccess('');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters long.');
      setSuccess('');
      return;
    }

    if (password.search(/[a-z]/i) < 0) {
      setError('Password must contain at least one letter.');
      setSuccess('');
      return;
    }
    if (password.search(/[0-9]/) < 0) {
      setError('Password must contain at least one digit.');
      setSuccess('');
      return;
    }

    // if (password.search(/[\W_]/) < 0) {
    //   setError('Password must contain at least one special character.');
    //   setSuccess('');
    //   return;
    // }

    if (password.search(/[\s]/) >= 0) {
      setError('Password must not contain any spaces.');
      setSuccess('');
      return;
    }

    const response = await axios.post(REGISTRATION_QUEUE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: {
        fullName: name,
        email: email,
        password: password,
      }
    })
    if (response.status === 200) {
      setSuccess(true);
      setName('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
    } else {
      setError('There was an issue with your registration. Please try again.');
    }
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f5f5f5' }}>
      <Paper sx={{ width: '100%', maxWidth: 400, padding: 3, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="h4" align="center" color="primary" gutterBottom>
        Pathvizor Registration
        </Typography>
        <TextField
          fullWidth
          label="Full Name"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          fullWidth
          label="Password"
          variant="outlined"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          fullWidth
          label="Confirm Password"
          variant="outlined"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
          {error && (
            <Box sx={{ color: 'error.main', fontSize: 14, mt: 1 }}>{error}</Box>
          )}
          {success && (
            <Box sx={{ color: 'success.main', fontSize: 14, mt: 1 }}>{success}</Box>
          )}
        <Button variant="contained" color="primary" fullWidth onClick={handleRegister} sx={{ marginBottom: 2 }}>
          Register
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <Link href="/login" sx={{ color: '#D6BF87', fontWeight: 'bold' }}>Already have an account? Login</Link>
        </Box>
      </Paper>

            {/* Success Snackbar */}
            <Snackbar
        open={success}
        // autoHideDuration={3000}
        onClose={() => setSuccess(false)}
      >
        <Alert onClose={() => setSuccess(false)} severity="success" sx={{ width: '100%' }}>
          Registration successful! We will be in touch with you soon!
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default RegistrationPage;
